import React, {memo} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {motion, AnimatePresence} from "motion/react";

import Icon from "@/components/Global/Icon/Icon";
import RenderIf from "@/components/Global/RenderIf/RenderIf";
import {config} from "@/config";

import styles from "./Box.module.scss";

const websiteId = config.websiteId;

export default memo(function Box({
  smallTitle = "",
  mainTitle = "",
  children,
  variant = websiteId == 2 ? "dark" : "light",
  showShadow = true,
  showGlow = false,
  className = "",
  lazyLoading = false,
  triggerMargin = "0px 0px -20px 0px",
  icon = "",
  faSize,
  iconSize,
  fullHeight = true,
  fullWidth = true,
  activeMotion = false,
  overwriteColours = true,
  ...rest
}) {
  // const ref = useRef();
  // const inView = useInView(ref, {
  //   margin: triggerMargin,
  //   once: true,
  // });

  return (
    <article
      // ref={ref}
      className={`${fullHeight ? "h-100" : ""} ${fullWidth ? "w-100" : ""}`}>
      {/* <RenderIf isTrue={(lazyLoading && inView) || !lazyLoading}> */}
      <AnimatePresence>
        <RenderIf isTrue={activeMotion}>
          <motion.div
            {...rest}
            layout
            data-variant={variant}
            data-show-shadow={showShadow}
            data-show-glow={showGlow}
            className={`${styles.box} ${styles.fadeIn} ${className}`}>
            <RenderIf isTrue={smallTitle || mainTitle}>
              <div className={"row px-3 pt-4"}>
                <div className="col">
                  <RenderIf isTrue={smallTitle}>
                    <h5
                      className={`text-uppercase ${styles.smallTitle}`}
                      dangerouslySetInnerHTML={{__html: smallTitle}}></h5>
                  </RenderIf>
                  <RenderIf isTrue={mainTitle}>
                    <h2 className="h1" dangerouslySetInnerHTML={{__html: mainTitle}}></h2>
                  </RenderIf>
                </div>
                <RenderIf isTrue={icon && !icon?.prefix?.includes("fa")}>
                  <div className="col-auto">
                    <Icon
                      icon={icon}
                      className={styles.icon}
                      style={{width: iconSize}}
                      overwriteColours={overwriteColours}
                    />
                  </div>
                </RenderIf>
                <RenderIf isTrue={icon?.prefix?.includes("fa")}>
                  <div className="col-auto">
                    <FontAwesomeIcon icon={icon} size={faSize} className={styles.faIcon} />
                  </div>
                </RenderIf>
              </div>
            </RenderIf>
            {children}
          </motion.div>
        </RenderIf>
      </AnimatePresence>

      <RenderIf isTrue={!activeMotion}>
        <div
          {...rest}
          variant={variant}
          data-show-shadow={showShadow}
          data-show-glow={showGlow}
          className={`${styles.box} ${styles.fadeIn} ${className}`}>
          <RenderIf isTrue={smallTitle || mainTitle}>
            <div className={"row px-3 pt-4"}>
              <div className="col">
                <RenderIf isTrue={smallTitle}>
                  <h5
                    className={`text-uppercase ${styles.smallTitle}`}
                    dangerouslySetInnerHTML={{__html: smallTitle}}></h5>
                </RenderIf>
                <RenderIf isTrue={mainTitle}>
                  <h2 className="h1" dangerouslySetInnerHTML={{__html: mainTitle}}></h2>
                </RenderIf>
              </div>
              <RenderIf isTrue={icon && !icon?.prefix?.includes("fa")}>
                <div className="col-auto">
                  <Icon
                    icon={icon}
                    className={styles.icon}
                    style={{width: iconSize}}
                    overwriteColours={overwriteColours}
                  />
                </div>
              </RenderIf>
              <RenderIf isTrue={icon?.prefix?.includes("fa")}>
                <div className="col-auto">
                  <FontAwesomeIcon icon={icon} size={faSize} className={styles.faIcon} />
                </div>
              </RenderIf>
            </div>
          </RenderIf>
          {children}
        </div>
      </RenderIf>
      {/* </RenderIf> */}
    </article>
  );
});
